import { baseEmailAssets, baseEmailTheme, TenantInfo } from '../common';
import { tos } from './tos';

export const tenant = {
  id: 'keet',
  name: 'KEETCargo',
  isSystemTenant: false,
  domains: [
    'keet.localhost',
    'keet.demo.pelicargo.dev',
    'keet.tenant.pelicargo.dev',
    'keetcargo.com',
    /keet\.staging-\d+\.pelicargo\.dev/,
  ],
  customerTheme: {
    colors: {
      primary: {
        '50': '#eaf5fb',
        '100': '#dff0f9',
        '200': '#bde1f4',
        '300': '#84c8ed',
        '400': '#2fa7e7',
        '500': '#0c6696',
        '600': '#0b608e',
        '700': '#075076',
        '800': '#03334d',
        '900': '#000b10',
      },
    },
    logoDims: {
      height: 30,
      width: 130,
    },
    fullLogoDims: {
      height: 30,
      width: 130,
    },
  },
  emailTheme: {
    ...baseEmailTheme,
    primary: '#0c6696',
  },
  emailAssets: {
    ...baseEmailAssets,
    logo: 'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/keet/logo.png',
    'logo-dark': 'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/keet/keet_qbs_dark.svg',
    'logo-dark-tagline':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/keet/keet_qbs_dark.svg',
    'logo-light': 'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/keet/keet_qbs.svg',
    'logo-light-tagline':
      'https://raw.githubusercontent.com/pelicargo/assets/refs/heads/master/tenants/keet/keet_qbs.svg',
    twitterUrl: 'https://to-be-determined/',
    facebookUrl: 'https://to-be-determined/',
    linkedinUrl: 'https://to-be-determined/',
    siteUrl: 'https://keetcargo.com/',
  },
  admin: {
    cruds: {
      accounts: true,
      providers: false,
      airports: false,
      contacts: true,
      instructions: false,
      users: true,
      backlogs: false,
      'ai-inbox': false,
      surcharges: false,
      rates: false,
      'route-editor': false,
      configuration: false,
    },
    inbox: {
      requestDrawers: {
        // Provider Facing
        ProviderQuoting: false,
        AirlineBooking: false,
        RequestSchedule: false,
        BookingChange: false,
        BookingCancel: false,

        // Customer Facing
        QuoteUpdate: true,
        BookingConfirmation: true,
        NewRate: true,
        RequestClarifications: true,
        Contact: true,
        GenericEmailToFF: true,
        StatusUpdate: true,
      },
    },
    features: {
      instructionCreation: false,
    },
  },
  accountTypes: {
    IAC: false,
    IATA: false,
    ORGANIZATION: false,
    UNCERTIFIED: true,
  },
  customer: {
    requestFormDefaults: {
      freight_service: 'EXW',
      is_consolidated: true,
      extra_freight_services: ['AES'],
    },
    freightServices: {
      UNCERTIFIED: ['EXW'],
      default: ['EXW'],
    },
    reamaze: {
      account: '448a08a5-c644-43b3-bd16-3aca3a90c39e',
      mailbox: '79780707',
      slug: 'app-dot-keetcargo-dot-com',
      widgetColor: '#0c6696',
      greeting: 'Hello, how can we help? 😊',
      confirmationMessage: 'A member of our staff will be with you momentarily or via email when we return! 😊',
    },
    copy: {
      'request.shipmentImporter.title': 'AI Shipments',
      'request.shipmentImporter.placeholder':
        'Copy and paste your shipment from email, text, etc. and we will automatically import it into the form for you',
    },
  },
  termsOfService: tos,
  helpUrl: 'https://docs.google.com/document/d/182b1al8Uyn5RobuZlV7MQJ0BYnonlJJIOwaqii6AmBk/edit?usp=sharing',
} as const satisfies TenantInfo<'keet'>;
